import { EDITOR_PASTE_PERFORMANCE } from '../../../types/AnalyticsTypes';
import getNodeLength from '../../../adapter/editor/utils/getNodeLength';
import { window } from '../../../helpers/BrowserHelpers';

var perfAnalyticsHelper = function perfAnalyticsHelper() {
  var timeBeforePasting;

  var start = function start() {
    timeBeforePasting = Date.now();
  };

  var end = function end(editor, fragment) {
    window.requestIdleCallback(function () {
      return editor.command('track', EDITOR_PASTE_PERFORMANCE, {
        paste_time: Date.now() - timeBeforePasting,
        chars_count: getNodeLength(fragment),
        blocks_count: fragment.nodes.size
      });
    });
  };

  return {
    start: start,
    end: end
  };
};

export default perfAnalyticsHelper();